import { atom } from "recoil";
import { IContatoHistoricoEmpresa } from "../../commons/types/crm";

export const contatoHistoricoEmpresaAtom = atom<IContatoHistoricoEmpresa>({
  key: 'contatoHistoricoEmpresa',
  default: {} as any,
})
